import { getOwnerId } from "../../../core/game/common/ReplicatedData";
import { ReplicatedAction } from "../../../core/game/interfaces/ReplicatedAction";
import { getPlayerPrefix } from "../../../core/util/PlayerUtils";
import { Contact3DLock } from "../Contact3DLock";
import { isValidEnglishWord } from "../util/Word";
;
function GuessClueAnswerValidator(data, context) {
    const { answer, } = data;
    const { gameState, clue } = context;
    if (answer.length <= 0 || gameState.secretWord === undefined) {
        return false;
    }
    if (!/^[a-zA-Z]+$/.test(answer)) {
        return `You need to guess single words with letters and numbers only!`;
    }
    if (!isValidEnglishWord(answer)) {
        return `You're probably gonna wanna try with a valid English word, knucklehead!`;
    }
    // Answer must match the revealed letters
    if (!answer.startsWith(gameState.secretWord.substring(0, gameState.numRevealedLetters))) {
        return `Your guess must match the revealed letters!`;
    }
    // There must be a clue out
    if (clue === undefined) {
        return `You can't guess an answer when there is no clue!`;
    }
    // Clue must not be a previous clue
    if (gameState.previousClues.includes(answer) && clue.clueAnswer !== answer) {
        return `${answer} has already been guessed or given as a clue before!`;
    }
    const sourceId = getOwnerId(data);
    // Clue must not already be deleting
    if ((clue.submittedAnswer !== undefined && sourceId !== gameState.secretWordGiverId)) {
        return `Somebody else is already guessing the clue right now!`;
    }
    // Can't send an answer before the banner timeout
    if ((context.locks.isLocked(Contact3DLock.AnswerSubmissionLock))) {
        return false;
    }
    if (sourceId === getOwnerId(clue)) {
        return `You can't guess your own clue!`;
    }
    return true;
}
function GuessClueAnswerEffect(data, context) {
    const sourceId = getOwnerId(data);
    const username = context.players.data.getPlayerUsername(sourceId);
    const { gameState, clue, } = context;
    const { answer } = data;
    if (sourceId === gameState.data.secretWordGiverId) {
        clue === null || clue === void 0 ? void 0 : clue.commitAnswerImmediate(answer, sourceId, getPlayerPrefix(username));
    }
    else {
        clue === null || clue === void 0 ? void 0 : clue.commitData({
            submittedAnswer: {
                answer: answer,
                sourceId: sourceId,
                sourceUsername: username !== null && username !== void 0 ? username : "unknown",
            }
        });
    }
}
export const GuessClueAnswer = new ReplicatedAction('GuessClueAnswer', GuessClueAnswerValidator, GuessClueAnswerEffect);
//# sourceMappingURL=GuessClueAnswer.js.map